import { OrmModel, StringField } from 'vuex-orm-decorators'
import { modelNames } from '@/data/models/types'
import Contact from '@/data/models/domain/Contact'

@OrmModel(modelNames.BLOCKED_CONTACT)
export default class BlockedContact extends Contact {
  @StringField('')
  public dateBlocked: string
}
